import React from 'react';
import { clsx } from 'clsx';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: { value: string; label: string }[];
}

export function Select({ label, error, options, className, ...props }: SelectProps) {
  return (
    <div className="flex flex-col gap-1">
      {label && <label className="text-sm text-tg-text-secondary">{label}</label>}
      <select
        className={clsx(
          'w-full rounded-md border border-tg-border px-3 py-2 text-sm text-tg-text outline-none transition-colors focus:border-tg-accent',
          error && 'border-tg-error',
          className
        )}
        style={{ background: 'var(--tg-bg-secondary)' }}
        {...props}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <span className="text-xs text-tg-error">{error}</span>}
    </div>
  );
}
